namespace Ir.Components.Workbook.ToolBar.FormattingRulesToolBar {
    interface IFormattingRulesToolBarViewModel {
        buttonOptions: any,
    }

    export function getViewModel(this: IFormattingRulesToolBarViewModel, params: any) {
        this.buttonOptions = {
            hint: 'Formatting Rules',
            template: `<i class="ms">colors</i> <span>Formatting Rules</span>`,
            disabled: ko.computed(function () {
                let enabled = loggedUser.permissions.editFormattingRules() || loggedUser.permissions.formattingRules();
                return !enabled;
            }),
            onClick(e) {
                FormattingRuleService.showEditor();
            }
        }
    }
}